module.exports = __webpack_public_path__ + "static/media/23.01ae01fa.jpg";